class QuantityControls extends HTMLElement {
  constructor() {
    super();
    this.minusButton = this.querySelector('[data-action="minus"]');
    this.plusButton = this.querySelector('[data-action="plus"]');
    this.input = this.querySelector('input[name="quantity"]');
    this.min = parseInt(this.input.min) || 1;
    this.max = this.input.max ? parseInt(this.input.max) : Infinity;
    this.updateButtons();
    this.initEvents();
  }

  updateButtons() {
    let value = parseInt(this.input.value);
    this.minusButton.disabled = value <= this.min;
    this.plusButton.disabled = value >= this.max;
  }

  initEvents() {
    this.minusButton.addEventListener('click', () => this.changeValue(-1));
    this.plusButton.addEventListener('click', () => this.changeValue(1));
    this.input.addEventListener('input', () => {
      if (this.input.value == 0) {
        this.input.value = 1;
      }
      this.updateButtons();
    });
  }

  changeValue(step) {
    let newValue = Math.min(Math.max(this.min, parseInt(this.input.value) + step), this.max);
    this.input.value = newValue;
    this.updateButtons();
  }
}
customElements.define('quantity-controls', QuantityControls);

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.initGallery();
  }

  initGallery() {
    let thumbsSlider = new Swiper('[data-product-gallery="thumbs"]', {
      navigation: {
        nextEl: '.product-gallery__thumbs-navigation_next',
        prevEl: '.product-gallery__thumbs-navigation_prev'
      },
      direction: 'vertical',
      slidesPerView: 3,
      loop: true,
      spaceBetween: 10,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 10
        }
      }
    });

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const direction = thumbsSlider.isHorizontal()
          ? 'horizontal'
          : 'vertical';

        const bodySizeIsMobile = entry.contentRect.width < 992;

        if (bodySizeIsMobile && direction === 'vertical') {
          thumbsSlider.changeDirection('horizontal');
        } else if(!bodySizeIsMobile && direction === 'horizontal') {
          thumbsSlider.changeDirection('vertical');
        }

      }
    });

    resizeObserver.observe(document.body);

    let thumbsVideoSlider = new Swiper('[data-product-gallery="thumbs-video"]', {
      navigation: {
        nextEl: '.product-gallery__thumbs-video-navigation_next'
      },
      direction: 'vertical',
      slidesPerView: 1,
      loop: true,
      spaceBetween: 5,
      watchSlidesProgress: true,
    });

    let gallerySlider = new Swiper('[data-product-gallery="gallery"]', {
      navigation: {
        nextEl: '.product-gallery__media-navigation_next',
        prevEl: '.product-gallery__media-navigation_prev'
      },
      pagination: {
        el: '.product-gallery__media-pagination'
      },
      loop: true,
      spaceBetween: 5,
      thumbs: {
        swiper: thumbsSlider
      }
    });

    thumbsVideoSlider.on('click', ()=> {
      setVideoSlide(thumbsVideoSlider.realIndex)
    })

    thumbsVideoSlider.on('slideChangeTransitionEnd', ()=> {
      setVideoSlide(thumbsVideoSlider.realIndex)
    })

    function setVideoSlide(realIndex) {
      let relatedIndex = document.querySelector(`[data-product-gallery="thumbs-video"] [data-swiper-slide-index="${realIndex}"]`).dataset.relatedIndex
      gallerySlider.slideTo(Number(relatedIndex), 300)
    }
  }
}
customElements.define('product-gallery', ProductGallery);

class ProductAddBar extends HTMLElement {
  constructor() {
    super();

    this.options = {
      productForm: '.product-form',
      activeClass: 'visible',
      addButtonBar: 'btn-add',
      addButtonProduct: '[data-add-to-cart]',
      notifyButtonBar: 'btn-notify',
      notifyButtonProduct: '.klaviyo-bis-trigger',
      retailerButtonProduct: '.mikmak-discover'
    };

    this.eventListeners();
  }

  eventListeners() {
    window.addEventListener('scroll', () => {
      let formPosition = document.querySelector(this.options.productForm).offsetTop + document.querySelector(this.options.productForm).offsetHeight + 150;
      if (window.pageYOffset > formPosition) {
        this.classList.add(this.options.activeClass)
      } else {
        this.classList.remove(this.options.activeClass)
      }
    });

    this.querySelector('.btn').addEventListener('click', () => {
      if (this.querySelector('.btn').classList.contains(this.options.addButtonBar)) {
        document.querySelector(this.options.addButtonProduct).click();
      } else if (this.querySelector('.btn').classList.contains(this.options.notifyButtonBar)) {
        document.querySelector(this.options.notifyButtonProduct).click();
      } else {
        document.querySelector(this.options.retailerButtonProduct).click();
      }
    })
  }
}

customElements.define('product-add-bar', ProductAddBar);